/**
 * @module Experience/landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

// It is not considering import as declaration , throwing lint error at import statement itself

// Core Dependencies
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// modules
import { SharedExperienceModule } from '@experience/shared-experience/shared-experience.module';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';
import { SharedModule } from '@support/shared/shared.module';
import { AemModule } from '@core/aem';
import { ProgressBarModule } from 'primeng/progressbar';

// Services
import { AccountLandingService } from '@experience/landing/common/components/account-landing/services/account-landing.service';
import { RemoveSuspensionService } from '@experience/landing/common/services/remove-suspension.service';
import { DeviceAssessmentService } from '@experience/device-assessment/service/device-assessment.service';
import { LineLandingService } from '@experience/landing/common/services/line-landing.service';
import { LineSelectorService } from '@experience/landing/common/components/line-selector/services/line-selector.service';
import { PendingOrdersService } from '@experience/change-plan-services/services/pending-orders.service';

// Components
import { HomeComponent } from './components/home/home.component';
import { AccountLandingComponent } from './components/account-landing/account-landing.component';
import { LineDetailsComponent } from './components/line-details/line-details.component';
import { UsageDetailComponent } from './components/usage-detail/usage-detail.component';
import { AlertsSectionComponent } from './components/alerts-section/alerts-section.component';
import { LineLandingComponent } from './components/line-landing/line-landing.component';
import { LineDeviceComponent } from './components/line-device/line-device.component';
import { LineUpgradeComponent } from './components/line-upgrade/line-upgrade.component';
import { LineRepActionsComponent } from './components/line-rep-actions/line-rep-actions.component';
import { PhonePipe } from '@support/shared/widgets/pipes/phone/phone.pipe';
import { AssistedLineLandingComponent } from '@experience/landing/common/components/line-landing/assisted-line-landing.component';
import { MonthlyChargesComponent } from '@experience/landing/common/components/monthly-charges/monthly-charges.component';
import { OneTimeChargesComponent } from './components/one-time-charges/one-time-charges.component';
import { PlanAndServicesComponent } from './components/plan-and-services/plan-and-services.component';
// routes
import { LANDING_COMMON_ROUTES } from '@experience/landing/common/landing-common.routes';
import { FoundPhoneModalComponent } from '@experience/landing/common/components/found-phone-modal/found-phone-modal.component';
import { LineSelectorComponent } from '@experience/landing/common/components/line-selector/line-selector.component';
import { AccountLineDetailsComponent } from '@experience/landing/common/components/account-line-details/account-line-details.component';
import { P10MLineDetailsComponent } from '@experience/landing/common/components/account-line-details/p10m-line-details/p10m-line-details.component';
// reb pdl
import { PdlModule } from '@experience/reb-pdl/pdl.module';
import { LinePendingOrdersComponent } from '@experience/landing/common/components/line-pending-orders/line-pending-orders.component';

import { LineDetailsTertiaryButtonComponent } from '@experience/landing/common/components/line-details-tertiary-buttons/line-details-tertiary-button.component';
import { RestoreServiceModalComponent } from '@experience/landing/common/components/restore-service-modal/restore-service-modal.component';

import { P10mUsageDetailComponent } from '@experience/landing/common/components/p10m-usage-details/p10m-usage-detail.component';
import { BillingBlockLandingModule } from './billing-block-landing.module';
/**
 * This module is the only experience module that is loaded on run time
 */
@NgModule({
  imports: [
    CommonModule,
    AemModule,
    WidgetsModule,
    ProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BillingBlockLandingModule,
    SharedExperienceModule,
    RouterModule.forChild(LANDING_COMMON_ROUTES),
    PdlModule.forChild(),
  ],
  declarations: [
    HomeComponent,
    AccountLandingComponent,
    LineDetailsComponent,
    UsageDetailComponent,
    AlertsSectionComponent,
    LineLandingComponent,
    LineDeviceComponent,
    LineUpgradeComponent,
    LineRepActionsComponent,
    AssistedLineLandingComponent,
    OneTimeChargesComponent,
    PlanAndServicesComponent,
    MonthlyChargesComponent,
    FoundPhoneModalComponent,
    LineSelectorComponent,
    AccountLineDetailsComponent,
    LinePendingOrdersComponent,
    RestoreServiceModalComponent,
    LineDetailsTertiaryButtonComponent,
    P10MLineDetailsComponent,
    P10mUsageDetailComponent,
  ],
  exports: [
    HomeComponent,
    AemModule,
    WidgetsModule,
    AlertsSectionComponent,
    OneTimeChargesComponent,
    LineLandingComponent,
    LineDetailsComponent,
    RestoreServiceModalComponent,
    LineRepActionsComponent,
  ],
  providers: [
    AccountLandingService,
    PhonePipe,
    RemoveSuspensionService,
    LineLandingService,
    DeviceAssessmentService,
    LineSelectorService,
    PendingOrdersService,
  ],
})
export class CommonLandingModule {}
